(ns frontend.view.entity-viewers.modules.tasks.event
  (:require [frontend.state.current-session :as session]
            [frontend.view.grid.tasks-grid.events :as tasks-events]
            [frontend.view.modals.activity-entity-editor.view :as activity-entity-editor]
            [frontend.view.modals.events :as modals]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::open-task
 (fn [_ [_ task]]
   (when-not (session/is-read-only-user?)
     (case (:task/type task)
       :task.type/webentry (tasks-events/handle-webentry task)
       :task.type/email (tasks-events/handle-email task)
       (modals/open-modal! activity-entity-editor/modal-key
                           {:entity-id (:db/id task)})))))
